// extracted by mini-css-extract-plugin
export default {"new_card_hr":"NewCardLayout_new_card_hr__7Ao6N"};